import { WARP_MODES } from './advancedSynthesisSchema';
// Compact, phase-preserving Fourier frames. Browser oscillators band-limit them.
const LIMIT = 64;
const bound = (v, lo, hi, fallback) => Number.isFinite(Number(v)) ? Math.min(hi, Math.max(lo, Number(v))) : fallback;
export function defaultWavetableFrames() {
  return ['Sine','Triangle','Saw','Square'].map((name, frame) => {
    const real = Array(LIMIT + 1).fill(0);
    const imag = real.map((_, h) => {
      if (!h) return 0;
      if (frame === 0) return h === 1 ? 1 : 0;
      if (frame === 1) return h % 2 ? (8 / Math.PI ** 2) * (h % 4 === 1 ? 1 : -1) / h ** 2 : 0;
      if (frame === 2) return 2 / Math.PI * (h % 2 ? 1 : -1) / h;
      return h % 2 ? 4 / Math.PI / h : 0;
    });
    return { name, real, imag };
  });
}
export function normalizeWavetable(table = {}) {
  const frames = Array.isArray(table.frames) && table.frames.length ? table.frames.slice(0,16) : defaultWavetableFrames();
  return { name: String(table.name || 'Classic Shapes').slice(0,100), position: bound(table.position,0,1,0.5), warpMode: WARP_MODES.includes(table.warpMode) ? table.warpMode : 'none', warp: bound(table.warp,0,1,0), scanRate: bound(table.scanRate,.01,20,.3), scanDepth: bound(table.scanDepth,0,1,0),
    frames: frames.map((frame, i) => ({ name: String(frame.name || `Frame ${i+1}`).slice(0,60),
      real: Array.from({length:LIMIT+1},(_,h) => h ? bound(frame.real?.[h],-4,4,0) : 0),
      imag: Array.from({length:LIMIT+1},(_,h) => h ? bound(frame.imag?.[h],-4,4,0) : 0) })) };
}
